
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/beeswax",
      function () {
        return require("private-next-pages/destinations/beeswax.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/beeswax"])
      });
    }
  